<script lang="ts">
  import { useFetchMicro } from "../../helpers/api";
  import { getMicroDiscounts } from "../../helpers/priceCalculator";
  import type { MicroDiscounts } from "../../helpers/types";
  import Card from "../atoms/Card.svelte";
  import Heading from "../atoms/Heading.svelte";
  import Loader from "../atoms/Loader.svelte";
  import Text from "../atoms/Text.svelte";
  import Error from "../molecules/Error.svelte";

  interface Props {
    hasTaxId: boolean;
    microIdWithTaxCode: number;
    microIdNoTaxCode: number;
    microOfferText: string;
    class?: string;
  }

  let {
    hasTaxId,
    microIdWithTaxCode,
    microIdNoTaxCode,
    microOfferText,
    class: className,
  }: Props = $props();

  let discounts: MicroDiscounts | undefined = $state();

  const microQuery = useFetchMicro(
    {
      zipcode: "93252",
      code: microOfferText,
    },
    {
      onSuccess: (data) => {
        discounts = getMicroDiscounts(data, microIdWithTaxCode, microIdNoTaxCode);
      },
    }
  );
</script>

{#if $microQuery.isError}
  <Error
    onClick={() => {
      $microQuery.refetch();
    }}
    >Något gick fel vid hämtning av produkt
  </Error>
{:else if $microQuery.isLoading}
  <Card class="h-40 bg-Neutral200 flex justify-center items-center">
    <Loader />
  </Card>
{:else if $microQuery.isSuccess}
  <Card class="p-3">
    <div class={className}>
      <div class="flex justify-between md:mt-3 md:mb-3 flex-col md:flex-row gap-2">
        <div class="text-left font-normal">
          <span class="text-H3 mr-3">Ersättning överskottsel</span>
          <div class="my-2">
            <Text variant="primary">
              Ersättningen baseras på kvartspotpriset, exklusive moms, under en period på 3 år. <br
              />
              Om du är momsregistrerad tillkommer moms.
            </Text>
          </div>
        </div>
        <div class="max-w-2xs md:text-right hidden md:block">
          <span class="text-Green700 text-H3 font-bold">Rörligt kvartspris</span>
        </div>
      </div>
    </div>
  </Card>
{/if}
